import MapElement from "./MapElement";
import LayerGroup from "ol/layer/Group";

export default class MapTaskInfo extends MapElement {
    constructor(map, id, mapElementSettings, parent) {
        super(map, id, mapElementSettings, parent);
    }

    addLayerToMap() {
        this.layer = new LayerGroup();
        this.mapModel.map.addLayer(this.layer);
    }

    addElement(mapElement) {
        this.mapElements.push(mapElement)
    }
}